export const GET_TOP_RANK_USER = 'GET_TOP_RANK_USER'
export const GET_TELLER_LIST = 'GET_TELLER_LIST'
export const GET_NEWS = 'GET_NEWS'
export const GET_USER = 'GET_USER'
export const GET_ANSWER_LIST = 'GET_ANSWER_LIST'
export const GET_TIMELINE_LIST = 'GET_TIMELINE_LIST'
export const LIKE_POST = 'LIKE_POST'
export const UNLIKE_POST = 'UNLIKE_POST'
